export default __webpack_public_path__ + "static/media/background-three-circles.72bb8262.svg";